import PageLoadHookRunner from './core/PageLoadHookRunner';
import DesktopManager from './ui/DesktopManager';
import UIManager from './ui/UIManager';

import $ from 'jquery';

class OsakaZone {
  public readonly loadHookRunner: PageLoadHookRunner = new PageLoadHookRunner();

  public readonly desktopManager: DesktopManager = new DesktopManager();

  public readonly uiManager: UIManager = new UIManager(this.desktopManager);

  public constructor() {
    this.loadHookRunner.hooks.push(this.desktopManager);
    this.loadHookRunner.hooks.push(this.uiManager);
  }

  public onPageLoad() {
    this.loadHookRunner.onPageLoad();
    console.log('YOU HAVE ENTERED THE OSAKA ZONE');
  }
}

const oz = new OsakaZone();

$(() => oz.onPageLoad());
